import {Paper} from "@mantine/core";
import {useContext, useEffect, useState} from "react";
import {Col, Row} from "../../../components/Flex/Flex";
import MessageContext from "../../../context/MessageContext";
import api from "../../../utils/api";



function ViewMembers({ faction }) {
    const {setLoaderMessage} = useContext(MessageContext);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        setLoaderMessage('Loading user list');
        api.get('/bh/manage/users/'+faction.id).then(res => {
            setUsers(res.data.sort((a,b) => a.handle.localeCompare(b.handle)));
            setLoaderMessage('');
        })
    }, [faction.id])


    return (
        <Paper>
            <p className="font-italic">This is the list of all users present on Forge that are recognized as part of your faction.</p>
            <hr />
            {users.map(u => <UserRow key={u.uid} user={u} />)}
        </Paper>
    )
}

const UserRow = ({user}) => {
    return (
        <Row>
            <Col>{user.handle}</Col>
        </Row>
    )
}


export default ViewMembers;
